import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import packingService from "../Services/packingService";

export default function AddProductsWithoutBarcode() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [packing, setPacking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await packingService.getSingle(id);
        if (res.responseCode === 200) {
          setPacking(res.packing);
        }
      } catch (err) {
        console.log("Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const updateQty = (index, value) => {
    setPacking((prev) => {
      const updatedProducts = [...prev.products];
      updatedProducts[index].quantityPlaced = value;
      return { ...prev, products: updatedProducts };
    });
  };

  // ✅ SAME LOGIC AS OTHER PAGE
  const allCompleted =
    Array.isArray(packing?.products) &&
    packing.products.every(
      (item) =>
        item.quantityPlaced !== null &&
        item.quantityPlaced !== "" &&
        item.quantityPlaced !== undefined &&
        Number(item.quantityPlaced) > 0
    );

  const handleSubmit = () => {
    navigate(`/packing/view/${packing.id}`);
  };

  if (loading)
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <p className="text-gray-600 text-lg">Loading...</p>
      </div>
    );

  if (!packing)
    return (
      <div className="flex items-center justify-center h-[50vh]">
        <p className="text-gray-500">Packing not found</p>
      </div>
    );

  return (
    <div className="mx-10 my-6 p-8 rounded-3xl border border-gray-200 shadow-lg bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-secondary">
            Add Products Without Barcode (Packing #{packing.id})
          </h1>
          <p className="text-gray-500">
            Editing packing of {packing.company_name}
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-md"
        >
          <ArrowLeft size={18} />
          Back
        </button>
      </div>

      {/* Packing Info */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <p className="text-gray-500 text-sm">Packing ID</p>
          <h3 className="font-semibold text-lg text-indigo-600">
            #{packing.id}
          </h3>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <p className="text-gray-500 text-sm">Created At</p>
          <h3 className="font-medium">
            {moment(packing.created_at).format("lll")}
          </h3>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg shadow-sm">
          <p className="text-gray-500 text-sm">Packing Date</p>
          <h3 className="font-medium">{moment(packing.date).format("ll")}</h3>
        </div>
      </div>

      {/* Products Table */}
      <h2 className="text-lg font-semibold mb-3">Edit Quantities</h2>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 text-sm">
          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th className="p-3 text-left">ID</th>
              <th className="p-3 text-left">Maker</th>
              <th className="p-3 text-left">Part No.</th>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Quantity</th>
              <th className="p-3 text-left">Edit Qty</th>
            </tr>
          </thead>

          <tbody>
            {packing.products.map((item, index) => (
              <tr key={index} className="border-t hover:bg-gray-50">
                <td className="p-3">{item.id}</td>
                <td className="p-3">{item.maker}</td>
                <td className="p-3">{item.partnumber}</td>
                <td className="p-3">{item.description || "-"}</td>
                <td className="p-3">{item.quantity}</td>

                <td className="p-3">
                  <input
                    type="number"
                    value={item.quantityPlaced || ""}
                    onChange={(e) => updateQty(index, e.target.value)}
                    className="border p-2 rounded w-24"
                    placeholder="0"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* COMPLETE BUTTON */}
      <div className="mt-6 flex justify-end">
        <button
          onClick={allCompleted ? handleSubmit : null}
          disabled={!allCompleted}
          className={`px-6 py-2 rounded-lg font-semibold shadow
              ${
                !allCompleted
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-green-600 hover:bg-green-700 text-white"
              }`}
        >
          Complete Packing
        </button>
      </div>
    </div>
  );
}
